import api from '@/api';

const resource = 'ei/periodo-avaliativo';

export default {
  getPeriodoTurmas(data) {
    return api.get(`${resource}/select-periodo-turma`, {
      params: data,
    });
  },
  getPeriodoDisciplina(data) {
    return api.get(`${resource}/select-periodo-disciplina`, {
      params: data,
    });
  },
  getPeriodoAvaliativo(data) {
    return api.get(`${resource}`, {
      params: data,
    });
  },
  getAulasPorPeriodo(data) {
    return api.get(`${resource}/aulas-por-periodo`, {
      params: data,
    });
  },
  getPeriodoFechamento(data) {
    return api.get(`${resource}/fechamento`, {
      params: data,
    });
  },
  getValoresPromocaoPeriodo(data) {
    return api.get(`${resource}/valorpromocaoporperiodo`, {
      params: data,
    });
  },
  getPeriodoAvaliativoPorEscola(params) {
    return api.get(`${resource}/getPeriodoAvaliativoPorEscola`, {
      params,
    });
  },
};
